import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import API from './resources/Api';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/home')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/login')
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('./views/users')
    },
    {
      path: '/users/new',
      name: 'newUser',
      component: () => import('./views/users/form')
    },
    {
      path: '/users/:id',
      name: 'editUser',
      component: () => import('./views/users/form')
    },
    {
      path: '/plans',
      name: 'plans',
      component: () => import('./views/plans')
    },
    {
      path: '/plans/new',
      name: 'newPlan',
      component: () => import('./views/plans/form')
    },
    {
      path: '/plans/:id',
      name: 'editPlan',
      component: () => import('./views/plans/form')
    },
    {
      path: '/partner_categories',
      name: 'partner_categories',
      component: () => import('./views/partner_categories')
    },
    {
      path: '/partner_categories/new',
      name: 'newPartnerCategory',
      component: () => import('./views/partner_categories/form')
    },
    {
      path: '/partner_categories/:id',
      name: 'editPartnerCategory',
      component: () => import('./views/partner_categories/form')
    },
    {
      path: '/services',
      name: 'services',
      component: () => import('./views/services')
    },
    {
      path: '/services/new',
      name: 'newService',
      component: () => import('./views/services/form')
    },
    {
      path: '/services/:id',
      name: 'editService',
      component: () => import('./views/services/form')
    },
    {
      path: '/histories',
      name: 'histories',
      component: () => import('./views/histories')
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('./views/settings/form')
    },
    {
      path: '/settings/:tab',
      component: () => import('./views/settings/form')
    },
    {
      path: '/contracts',
      name: 'contracts',
      component: () => import('./views/contracts')
    },
    {
      path: '/contracts/new',
      name: 'newContract',
      component: () => import('./views/contracts/form')
    },
    {
      path: '/contracts/:contract_id/associates',
      name: 'ContractAssociates',
      component: () => import('./views/contracts/associates')
    },
    {
      path: '/contracts/:contract_id/associates/new',
      name: 'newContractAssociate',
      component: () => import('./views/contracts/associates/form')
    },
    {
      path: '/contracts/:contract_id/associates/:id',
      name: 'editContractAssociate',
      component: () => import('./views/contracts/associates/form')
    },
    {
      path: '/contracts/:id',
      name: 'editContract',
      component: () => import('./views/contracts/form')
    },
    {
      path: '/calls',
      name: 'Calls',
      component: () => import('./views/calls')
    },
    {
      path: '/calls/new',
      name: 'newCall',
      component: () => import('./views/calls/form')
    },
    {
      path: '/calls/:id',
      name: 'editCall',
      component: () => import('./views/calls/form')
    },
    {
      path: '/contracts-audit',
      name: 'contract_audit_report',
      component: () => import('./views/contracts/audit')
    },
    {
      path: '/contracts/:contract_id/invoices',
      name: 'contract_invoices',
      component: () => import('./views/invoices')
    },
    {
      path: '/contracts/:contract_id/invoices/new',
      name: 'new_contract_invoice',
      component: () => import('./views/invoices/form')
    },
    {
      path: '/contracts/:contract_id/invoices/:id',
      name: 'edit_contract_invoice',
      component: () => import('./views/invoices/form')
    },
    {
      path: '/contracts/:contract_id/procedure_authorizations',
      name: 'contract_procedure_authorizations',
      component: () => import('./views/procedure_authorizations')
    },
    {
      path: '/contracts/:contract_id/procedure_authorizations/new',
      name: 'new_contract_procedure_authorization',
      component: () => import('./views/procedure_authorizations/form')
    },
    {
      path: '/contracts/:contract_id/procedure_authorizations/:id',
      name: 'edit_contract_procedure_authorization',
      component: () => import('./views/procedure_authorizations/form')
    },
    {
      path: '/profiles',
      name: 'profiles',
      component: () => import('./views/profiles')
    },
    {
      path: '/profiles/new',
      name: 'newProfile',
      component: () => import('./views/profiles/form')
    },
    {
      path: '/profiles/:id',
      name: 'editProfile',
      component: () => import('./views/profiles/form')
    },
    {
      path: '/permissions',
      name: 'permissions',
      component: () => import('./views/permissions/form')
    },
    {
      path: '/saae-payments-imports',
      name: 'saaePaymentsImports',
      component: () => import('./views/saae_payments_imports')
    },
    {
      path: '/saae-payments-imports/new',
      name: 'newSaaePaymentsImport',
      component: () => import('./views/saae_payments_imports/form')
    },
    {
      path: '/saae-payments-imports/:id',
      name: 'showSaaePaymentsImport',
      component: () => import('./views/saae_payments_imports/show')
    },
    {
      path: '/credit_card/:contract',
      name: 'creditCard',
      component: () => import('./views/credit_card')
    },
    {
      path: '/reports/procedure_authorizations',
      name: 'reportProcedureAuthorizations',
      component: () => import('./views/reports/procedure_authorizations')
    },
    {
      path: '/reports/contract-list',
      name: 'reportContractList',
      component: () => import('./views/reports/contracts')
    },
    {
      path: '/reports/owners',
      name: 'reportOwnersList',
      component: () => import('./views/reports/owners')
    },
    {
      path: '/reports/associates',
      name: 'reportAssociatesList',
      component: () => import('./views/reports/associates')
    },
    {
      path: '/reports/insurance',
      name: 'reportInsurance',
      component: () => import('./views/reports/insurance')
    },
    {
      path: '/reports/receipt',
      name: 'reportReceipt',
      component: () => import('./views/reports/receipt')
    },
    {
      path: '/reports/contracts-by-city',
      name: 'reportContractsByCity',
      component: () => import('./views/reports/contracts_by_city')
    },
    {
      path: '/reports/contract-list-by-collaborator',
      name: 'reportContractListByCollaborator',
      component: () => import('./views/reports/contracts_by_collaborator')
    },
    {
      path: '/reports/invoices',
      name: 'reportInvoiceList',
      component: () => import('./views/reports/invoices')
    },
    {
      path: '/reports/billing',
      name: 'reportBilling',
      component: () => import('./views/reports/billing')
    },
    {
      path: '/ai-chat',
      name: 'aiChat',
      component: () => import('./views/ai_chat')
    },
    {
      path: '/analytics/mrr',
      name: 'MRRAnalytics',
      component: () => import('./views/analytics/mrr')
    },
    {
      path: '/p',
      name: 'partner',
      component: () => import('./views/partner'),
      meta: {
        rule: 'partner'
      }
    },
    {
      path: '/p/contracts/:id',
      name: 'partnerContract',
      component: () => import('./views/partner/contracts/show'),
      meta: {
        rule: 'partner'
      }
    },
    {
      path: '/disabled',
      name: 'disabled',
      component: () => import('@/views/disabled')
    },
    {
      path: '*',
      component: () => import('@/views/page_not_found')
    }
  ]
});

const ruleMatch = function (rule) {
  const userRule = store.state.user.user.rule;
  if (userRule == null) {
    return false;
  }

  if (rule == null) {
    if (['admin', 'collaborator'].includes(userRule)) {
      return true;
    } else {
      return false;
    }
  }

  if (userRule != rule) {
    return false;
  }

  return true;
};

const isDisabled = function () {
  const disabledClients = process.env.VUE_APP_DISABLED
    ? JSON.parse(process.env.VUE_APP_DISABLED)
    : [];
  return disabledClients.includes(API.getSubdomain());
};

router.beforeEach((to, from, next) => {
  const publicPages = ['login', 'creditCard', 'disabled'];
  store.commit('nav/updatePrevious', from.fullPath);

  if (to.name !== 'disabled' && isDisabled()) {
    next({ name: 'disabled' });
  } else {
    if (publicPages.includes(to.name)) {
      next();
    } else if (store.getters['user/isLogged'] && ruleMatch(to.meta?.rule)) {
      next();
    } else {
      next({ path: '/login' });
    }
  }
});

export default router;
